'use client';

import { useWatch } from 'react-hook-form';
import QuestionsAnswers from './QuestionsAnswers';
import TechnicalComplaintsInput from './TechnicalComplaints';

const QualityDeviationsInputs = () => {
  const NotificationCategory = useWatch({
    name: 'notificationCategoryId.inputValue',
  });

  if (NotificationCategory && NotificationCategory === '45') {
    return (
      <>
        <TechnicalComplaintsInput></TechnicalComplaintsInput>

        <QuestionsAnswers></QuestionsAnswers>
      </>
    );
  }
};

export default QualityDeviationsInputs;
